import {Observable} from 'rxjs';

import IErrorsPayload from '../../../Player/Interfaces/IErrorsPayload';
import logger         from '../../../Shared/Util/logger';
import IAnalytics     from '../../Shared/Interfaces/IAnalytics';
import Conviva        from '../Vendor/Conviva';

const subscribeToErrors = (
    errors$: Observable<IErrorsPayload>,
    client: Conviva.Client,
    analytics: IAnalytics
) =>
    errors$
        .subscribe(errorPayload => {
            client.reportError(
                analytics.resolveSessionKey(),
                errorPayload.type,
                Conviva.Client.ErrorSeverity.FATAL
            );

            logger.log(`[Conviva] Reporting error ${errorPayload.type}`);
        });

export default subscribeToErrors;